import type { SVGProps } from 'react';

// 배경색과 느낌표 색이 상반되어야 함. 그런데 currentColor로는 한 가지 색으로만 적용할 수 밖에 없는 딜레마가 있음.
const SvgErrorFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <circle cx={12} cy={12} r={10} fill='#FF4040' />
    <path
      d='M12 14.999C12.5522 14.999 12.9998 15.4469 13 15.999C13 16.5513 12.5523 16.999 12 16.999C11.4478 16.9989 11 16.5512 11 15.999C11.0002 15.447 11.4479 14.9991 12 14.999ZM12 7.09863C12.4969 7.09863 12.9002 7.50215 12.9004 7.99902V12.499C12.9004 12.9961 12.4971 13.3994 12 13.3994C11.5031 13.3992 11.0996 12.996 11.0996 12.499V7.99902C11.0998 7.50225 11.5032 7.0988 12 7.09863Z'
      fill='white'
    />
  </svg>
);
export default SvgErrorFilled;
